// Black
export const BLACK = '#000000';
// Almost-Black
export const WOODSMOKE = '#17181a';
// Gray-1
export const ABBEY = '#484a4d';
// Gray-2
export const OSLO_GRAY = '#6a6d70';
// Gray-3
export const SILVER_SAND = '#babcbf';
// Gray-4
export const IRON = '#d4d7d9';
// Gray-5
export const PORCELAIN = '#e8ebed';
// Gray-6
export const AQUA_HAZE = '#f7f9fa';
// Gray-7
export const ALTO = '#d8d8d8';
// White
export const WHITE = '#ffffff';
// Blue
export const DODGER_BLUE = '#409fff';
// Red
export const FLAMINGO = '#e65050';
// Blue Hover
export const SCIENCE_BLUE = '#0073e5';
// Splashpage - Plans - Gold - Button - Right background
export const SUN = '#fcb315';
// Splashpage - Plans - Purple - Button - Right backround
export const GOLDEN_ROD = '#fbd767';
// Splashpage - Experiemnt - Background color
export const DARK_BLUE = '#1F2758';
// Mobile nav, custom home header to match artwork
export const TRADEWIND = '#6ab5bb';

// Download arrow on the metadata status
export const DUSTY_GRAY = '#979797';

// Color variants from the updated brand guidelines
export const WT_BLUE = '#3a66ff';
export const WT_YELLOW = '#fcc136';
export const WT_RED = '#f65a5a';
export const WT_ORANGE = '#ff7b22';
export const WT_GREEN = '#6ccc8c';
export const WT_PURPLE = '#915cee';
